'use strict';

const Swiper = require('swiper').Swiper;
const { Navigation, Pagination, Autoplay } = require('swiper/modules');

const swipers = {};

/**
 * Configures Swiper options based on data attributes and carousel ID.
 * @function
 * @param {Object} options - Raw options from data attribute.
 * @param {string} carouselId - Unique identifier for the carousel.
 * @returns {Object} Configured Swiper options.
 */
function configureSwiperOptions(options, carouselId) {
    const loop = !$('html').hasClass('ua-safari');
    const configuredOptions = { ...options };

    configuredOptions.loop = configuredOptions.loop === true ? loop : configuredOptions.loop;
    configuredOptions.modules = [Navigation, Pagination, Autoplay];
    configuredOptions.direction = 'horizontal';

    if (configuredOptions.showArrows) {
        configuredOptions.navigation = {
            nextEl: `#${carouselId}next`,
            prevEl: `#${carouselId}prev`,
        };
    }

    if (configuredOptions.showSwatches) {
        configuredOptions.pagination = {
            el: `#${carouselId}pag`,
            clickable: true
        };
    }

    // Configuración de Autoplay
    if (configuredOptions.autoplay) {
        configuredOptions.autoplay = {
            delay: configuredOptions.autoplayDelay || 3000,
            disableOnInteraction: false
        };
    } else {
        configuredOptions.autoplay = false;
    }

    // Limpieza de propiedades auxiliares
    delete configuredOptions.showArrows;
    delete configuredOptions.showSwatches;
    delete configuredOptions.autoplayDelay;

    return configuredOptions;
}

/**
 * Removes the slides that carry no markup, so Swiper does not count them.
 * A Page Designer component that discards itself returns an empty string, but the platform
 * still emits its wrapper element, which would otherwise show up as a blank slide.
 * @function
 * @param {jQuery} $container - jQuery object representing the slider container.
 */
function removeEmptySlides($container) {
    $container.find('.swiper-wrapper > .swiper-slide').filter(function() {
        return !$.trim($(this).html());
    }).remove();
}

/**
 * Initializes a new Swiper instance for a given container.
 * @function
 * @param {jQuery} $container - jQuery object representing the slider container.
 */
function initializeSwiperInstance($container) {
    const carouselId = $container.data('carousel-id');
    const rawOptions = $container.data('swiper-options');
    const swiperOptions = configureSwiperOptions(rawOptions, carouselId);

    removeEmptySlides($container);

    swipers[carouselId] = new Swiper(`#${carouselId}`, swiperOptions);
}

/**
 * Handles intersection changes for observed elements.
 * @function
 * @param {IntersectionObserverEntry[]} entries - Array of intersection entries.
 * @param {IntersectionObserver} observer - The Intersection Observer instance.
 */
function handleIntersection(entries, observer) {
    entries.forEach(entry => {
        if (entry.isIntersecting) {
            const $container = $(entry.target);
            const carouselId = $container.data('carousel-id');
            if (!swipers[carouselId]) {
                initializeSwiperInstance($container);
            }
            observer.unobserve(entry.target);
        }
    });
}

/**
 * Sets up intersection observer for lazy loading
 */
function setupObserver() {
    const observer = new IntersectionObserver(handleIntersection, {
        rootMargin: '100px'
    });

    $('.lazy-load-carousel').each(function() {
        observer.observe(this);
    });
}

/**
 * Sets up event listeners for async carousel initialization
 */
function setupEventListeners() {
    $('body').on('carousel:setup', (e, data) => {
        const $container = $(`#${data.carouselId}`);
        initializeSwiperInstance($container);
    });
}

function initNonSwiperScroll() {
    if ('ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0) { // Check if its mobile by touchscreen
        $('.category-grid-swiper:not(.swiper-initialized)').each(function() {
            var $container = $(this);
            var startX, startY, scrollLeft;
            var isScrollingHorizontally = false;

            $container.on({
                'touchstart': function(e) {
                    startX = e.touches[0].pageX - $container.offset().left;
                    startY = e.touches[0].pageY;
                    scrollLeft = $container.scrollLeft();
                    isScrollingHorizontally = false;
                },
                'touchmove': function(e) {
                    if (!startX) return;
                    var x = e.touches[0].pageX - $container.offset().left;
                    var y = e.touches[0].pageY;
                    var walkX = x - startX;
                    var walkY = y - startY;

                    if (!isScrollingHorizontally) {
                        isScrollingHorizontally = Math.abs(walkX) > Math.abs(walkY);
                        if (!isScrollingHorizontally) return;
                    }

                    $container.scrollLeft(scrollLeft - walkX);
                    e.preventDefault();
                },
                'touchend': function() {
                    startX = startY = null;
                    isScrollingHorizontally = false;
                }
            });
        });
    }
}

function initSwiper() {
    $('.experience-region.experience-slides').children('.swiper-slide').unwrap();
    setupEventListeners();
    setupObserver();
}

module.exports = {
    initSwiper: initSwiper,
    initNonSwiperScroll: initNonSwiperScroll
};
